



























































import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import InformationKey from "@/components/information-key";
import loginLogo from "@/assets/svg/loginLogo.svg";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const informationStore = inject(InformationKey);
    if (!informationStore) {
      throw new Error(`${InformationKey} is not provided`);
    }

    const loading = computed(() => displayuiStore.loading);
    const successSnackBar = computed(() => displayuiStore.successSnackBar);
    const errorSnackBar = computed(() => displayuiStore.errorSnackBar);
    const showBurgerMenuFlag = computed(
      () => displayuiStore.showBurgerMenuFlag
    );
    const newInformationFlag = computed(
      () => informationStore.newInformationFlag
    );

    const drawer = ref<boolean>(false);

    const globalStore = context.root.$store;
    const cyuricaCardNo = computed(() => globalStore.auth.cyuricaCardNo);

    return {
      drawer,
      successSnackBar,
      errorSnackBar,
      loading,
      cyuricaCardNo,
      newInformationFlag,
      showBurgerMenuFlag
    };
  },
  components: {
    loginLogo
  }
});
